export { BeamCommunityImpact } from './BeamCommunityImpact';